import { FormGroup, FormParagraph } from '@ksyos/design-system';
import { get } from 'lodash';
import type { FundingError } from '@common/interfaces/api/fundingResultsApi';
import { getSelectedLanguage } from '@frontend/translate';

type FundingErrorDetailsProps = {
    fundingError: FundingError;
};

export function FundingErrorDetails({ fundingError }: FundingErrorDetailsProps) {
    const { errorCode, fundingErrorInformation } = fundingError;

    const translate = getSelectedLanguage();

    return (
        <>
            <FormGroup label={translate.request.fundingError}>
                <FormParagraph>{translate.fundingErrorCode[errorCode]}</FormParagraph>
            </FormGroup>

            {fundingErrorInformation && (
                <FormGroup label={translate.request.fundingErrorInformation}>
                    <FormParagraph>{getFundingErrorInformation()}</FormParagraph>
                </FormGroup>
            )}
        </>
    );

    function getFundingErrorInformation() {
        return fundingErrorInformation && fundingErrorInformation in translate.fundingErrorInformationEnum
            ? get(translate.fundingErrorInformationEnum, fundingErrorInformation)
            : fundingErrorInformation;
    }
}
